import React, { useEffect, useState } from 'react';
import Select from 'react-select-virtualized';
import { StylesConfig } from 'react-select';
import OptionTypeBase from 'react-select';
import { BASE_URI } from '../Config';

const customStyles: StylesConfig<OptionTypeBase, false> = {
  option: (provided) => ({
    ...provided,
    fontWeight: 'normal'
  }),
  singleValue: (provided) => ({
    ...provided,
    fontWeight: 'normal'
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    fontWeight: 'normal'
  }),
};

interface AlleleOption {
    value: string,
    label: string
}

interface AlleleSearchSelect {
    onValueChange: (value: string | null) => void;
  }

const AlleleSearchSelect: React.FC<AlleleSearchSelect> = ({ onValueChange }) => {
  const [items, setItems] = useState<AlleleOption[]>([]);
//   const debouncedInputValue = useDebounce(inputValue, 1000); // Debounced value
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${BASE_URI}/jobs/allele_list`);
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setItems(data.map((item: string) => ({
            value: item,
            label: item,
          })) );
      } catch (error) {
        console.error('Failed to fetch data', error);
      }
    };
    fetchData();
  }, []);

  return (
    <Select 
      options={items}
    //   isSearchable={true}
      placeholder="Search MHC alleles..."
      onChange={
            (allele: AlleleOption | null) => { 
                if (allele) { 
                    onValueChange(allele.value) 
                }
                else { 
                    onValueChange(null) 
                } 
    }}
      styles={customStyles}
    />
  );
};

export default AlleleSearchSelect;
